import { render } from "./MyInfoSetting.vue?vue&type=template&id=70dcd15c&scoped=true"
import script from "./MyInfoSetting.vue?vue&type=script&lang=js"
export * from "./MyInfoSetting.vue?vue&type=script&lang=js"

import "./MyInfoSetting.vue?vue&type=style&index=0&id=70dcd15c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dcd15c"],['__file',"src/views/qywx/common/mine/MyInfoSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70dcd15c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70dcd15c', __exports__)) {
    api.reload('70dcd15c', __exports__)
  }
  
  module.hot.accept("./MyInfoSetting.vue?vue&type=template&id=70dcd15c&scoped=true", () => {
    api.rerender('70dcd15c', render)
  })

}


export default __exports__